import { useMutation, useQueryClient } from '@tanstack/react-query'
import { userTaskHostRescuedService } from '../../../../../services/users-tasks/users-tasks-hosts/users-tasks-hosts-rescued'
import { USERS_TASKS_HOSTS_DEFAULTS_QUERY_KEY } from '../../defaults/users-tasks-hosts-defaults/use-get-users-tasks-hosts-defaults'
import { USER_TASK_HOST_FIRST_QUERY_KEY } from '../use-get-user-task-host'

export const useRescuedHostTask = () => {
  const queryClient = useQueryClient()

  const { mutateAsync, isPending } = useMutation({
    mutationFn: userTaskHostRescuedService.rescued,
    onSettled() {
      queryClient.invalidateQueries({
        queryKey: [USER_TASK_HOST_FIRST_QUERY_KEY],
        exact: false,
      })

      queryClient.invalidateQueries({
        queryKey: [USERS_TASKS_HOSTS_DEFAULTS_QUERY_KEY],
        exact: false,
      })
    },
  })

  return {
    isLoading: isPending,
    rescue: mutateAsync,
  }
}
